// front-end/src/components/certificates-loader/certificates-loader.js

import {apiGet} from '../../utils/api';
import {config} from '../../config/app-config';
import {applyContentToElement, loadContentForElement} from '../content-editor-src';
import {isAuthenticated} from '../auth';
import {addDeleteButton} from '../block-system/block-manager/block-editor';
import {initSortable, makeBlockDraggable} from '../block-system/block-manager/block-sortable';
import {setupEditButton} from '../content-editor-src/content-editor/element-setup';

export class CertificatesLoader {
    constructor() {
        console.log('[CertificatesLoader] Инициализация начата');
        this.currentOffset = 0;
        this.itemsPerPage = 5;
        this.isLoading = false;
        this.hasMoreCertificates = true;
        this.container = null;
        this.loadMoreButton = null;
        this.isAuthenticated = isAuthenticated();
        this.initialized = false;
        this.loadedCertificatesCount = 0;

        // Проверяем мобильное устройство
        this.isMobile = this.checkIfMobile();
        console.log('[CertificatesLoader] Мобильное устройство:', this.isMobile);

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                setTimeout(() => this.init(), 800);
            });
        } else {
            setTimeout(() => this.init(), 800);
        }
    }

    // Проверка на мобильное устройство
    checkIfMobile() {
        const width = window.innerWidth;
        const isMobileWidth = width <= 768;
        console.log('[CertificatesLoader] checkIfMobile - width:', width, 'isMobile:', isMobileWidth);
        return isMobileWidth;
    }

    init() {
        if (this.initialized) {
            console.log('[CertificatesLoader] Уже инициализирован, пропускаем');
            return;
        }

        console.log('[CertificatesLoader] init() - начало');

        try {
            const {initializeBlockCounters} = require('../block-system/block-manager/block-state');
            initializeBlockCounters();
            console.log('[CertificatesLoader] Счетчики блоков инициализированы');
        } catch (error) {
            console.error('[CertificatesLoader] Ошибка инициализации счетчиков:', error);
        }

        if (window.location.pathname.match(/certificates(\.html)?$/)) {
            console.log('[CertificatesLoader] Страница certificates - ищем контейнер');
            this.initElements();

            // Добавляем обработчик изменения размера окна
            this.setupResizeHandler();
        } else {
            console.log('[CertificatesLoader] Не страница certificates, пропускаем инициализацию');
        }
    }

    // Настройка обработчика изменения размера окна
    setupResizeHandler() {
        let resizeTimeout;
        const handleResize = () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                const wasMobile = this.isMobile;
                const isNowMobile = this.checkIfMobile();

                console.log('[CertificatesLoader] Проверка resize:', {
                    wasMobile,
                    isNowMobile,
                    windowWidth: window.innerWidth
                });

                // Если изменился режим - перерисовываем существующие элементы
                if (wasMobile !== isNowMobile) {
                    console.log('[CertificatesLoader] Режим изменился! Перестраиваем сертификаты');
                    this.isMobile = isNowMobile;
                    this.rebuildExistingCertificates();
                }
            }, 150);
        };

        window.addEventListener('resize', handleResize);
        console.log('[CertificatesLoader] Resize handler установлен');
    }

    initElements() {
        this.container = document.querySelector('[data-section="certificates-section"]');

        if (!this.container) {
            const casesSection = document.querySelector('.cases-section');
            if (casesSection) {
                const certificatesSection = document.createElement('div');
                certificatesSection.className = 'certificates-list-section';
                certificatesSection.setAttribute('data-section', 'certificates-section');
                certificatesSection.innerHTML = '<div class="container-fluid"></div>';

                casesSection.insertAdjacentElement('afterend', certificatesSection);
                this.container = certificatesSection.querySelector('.container-fluid');
            }
        }

        this.loadMoreButton = document.querySelector('.load-more-certificates');

        console.log('[CertificatesLoader] Контейнер найден:', !!this.container);
        console.log('[CertificatesLoader] Кнопка загрузки найдена:', !!this.loadMoreButton);

        if (this.container) {
            this.initialized = true;
            console.log('[CertificatesLoader] Настраиваем обработчики');

            if (this.container.dataset.ssr) {
                const existingBlocks = this.container.querySelectorAll('[data-block-name^="certificate-block-"]');
                this.currentOffset = existingBlocks.length;
                this.loadedCertificatesCount = existingBlocks.length;
                if (this.isAuthenticated) {
                    initSortable(this.container);
                }
                this.setupLoadMoreButton();
                if (existingBlocks.length < this.itemsPerPage) {
                    this.hasMoreCertificates = false;
                    this.updateLoadMoreButton('no-more');
                }
                // Fill any images left empty by SSR (e.g. newly added certificates)
                this._fillEmptySsrImages();
            } else {
                this.clearExistingBlocks();

                if (this.isAuthenticated) {
                    initSortable(this.container);
                }

                this.setupLoadMoreButton();
                this.loadInitialCertificates();
            }
        } else {
            console.warn('[CertificatesLoader] Контейнер certificates-section не найден!');
        }
    }

    clearExistingBlocks() {
        const certificateBlocks = this.container.querySelectorAll('[data-block-name^="certificate-block-"]');
        console.log(`[CertificatesLoader] Удаляем ${certificateBlocks.length} существующих блоков сертификатов`);
        certificateBlocks.forEach(block => block.remove());
    }

    setupLoadMoreButton() {
        if (this.loadMoreButton) {
            const newButton = this.loadMoreButton.cloneNode(true);
            this.loadMoreButton.parentNode.replaceChild(newButton, this.loadMoreButton);
            this.loadMoreButton = newButton;

            this.loadMoreButton.addEventListener('click', (e) => {
                e.preventDefault();
                this.loadMoreCertificates();
            });

            console.log('[CertificatesLoader] Кнопка "загрузить больше" настроена');
        }
    }

    async loadInitialCertificates() {
        console.log('[CertificatesLoader] loadInitialCertificates() - начало');

        try {
            this.currentOffset = 0;
            this.loadedCertificatesCount = 0;
            this.hasMoreCertificates = true;

            this.clearExistingBlocks();
            await this.loadCertificatesChunk(0);

        } catch (error) {
            console.error('[CertificatesLoader] Ошибка при загрузке начальных сертификатов:', error);
            this.renderErrorState();
        }
    }

    async loadMoreCertificates() {
        if (this.isLoading || !this.hasMoreCertificates) {
            console.log('[CertificatesLoader] Загрузка уже идет или нет больше сертификатов');
            return;
        }

        console.log('[CertificatesLoader] loadMoreCertificates() - загружаем еще сертификаты');

        try {
            await this.loadCertificatesChunk(this.currentOffset);
        } catch (error) {
            console.error('[CertificatesLoader] Ошибка при загрузке дополнительных сертификатов:', error);
            this.showLoadMoreError();
        }
    }

    async loadCertificatesChunk(offset) {
        console.log(`[CertificatesLoader] loadCertificatesChunk() - offset: ${offset}, limit: ${this.itemsPerPage}`);

        this.isLoading = true;
        this.updateLoadMoreButton('loading');

        try {
            const apiUrl = `${config.api.paths.certificates}?offset=${offset}`;
            console.log('[CertificatesLoader] API URL:', apiUrl);

            const response = await apiGet(apiUrl, {auth: false});
            console.log('[CertificatesLoader] Ответ получен:', response);

            let certificateItems = Array.isArray(response) ? response : [];

            console.log('[CertificatesLoader] Количество сертификатов от API:', certificateItems.length);

            if (certificateItems.length > 0) {
                await this.renderCertificatesChunk(certificateItems);

                this.currentOffset += certificateItems.length;
                this.loadedCertificatesCount += certificateItems.length;

                console.log(`[CertificatesLoader] Offset обновлен до: ${this.currentOffset}`);
                console.log(`[CertificatesLoader] Всего загружено сертификатов: ${this.loadedCertificatesCount}`);

                if (certificateItems.length < this.itemsPerPage) {
                    console.log('[CertificatesLoader] Получено меньше сертификатов чем запрашивали - это последний чанк');
                    this.hasMoreCertificates = false;
                    this.updateLoadMoreButton('no-more');
                } else {
                    console.log('[CertificatesLoader] Есть еще сертификаты, кнопка остается активной');
                    this.updateLoadMoreButton('ready');
                }
            } else {
                if (offset === 0) {
                    console.log('[CertificatesLoader] Это был первый запрос - показываем пустое состояние');
                    this.renderEmptyState();
                }
                this.hasMoreCertificates = false;
                this.updateLoadMoreButton('no-more');
            }

        } catch (error) {
            console.error('[CertificatesLoader] Ошибка при загрузке чанка сертификатов:', error);
            throw error;
        } finally {
            this.isLoading = false;
        }
    }

    async renderCertificatesChunk(certificateItems) {
        console.log(`[CertificatesLoader] renderCertificatesChunk() - рендерим ${certificateItems.length} сертификатов`);

        const certificateElements = [];

        for (let i = 0; i < certificateItems.length; i++) {
            const certificate = certificateItems[i];
            console.log(`[CertificatesLoader] Обрабатываем сертификат ${i + 1}:`, certificate.data_block_name);

            try {
                const certificateElement = this.createCertificateElement(certificate, this.loadedCertificatesCount + i);
                this.container.appendChild(certificateElement);
                certificateElements.push(certificateElement);

                console.log(`[CertificatesLoader] Сертификат ${certificate.data_block_name} добавлен в DOM`);
            } catch (error) {
                console.error(`[CertificatesLoader] Ошибка при создании элемента сертификата:`, error);
            }
        }

        for (let i = 0; i < certificateElements.length; i++) {
            const certificateElement = certificateElements[i];
            const certificate = certificateItems[i];

            try {
                await this.loadCertificateContent(certificateElement, certificate);
                console.log(`[CertificatesLoader] Контент загружен для ${certificate.data_block_name}`);
            } catch (error) {
                console.error(`[CertificatesLoader] Ошибка при загрузке контента:`, error);
            }
        }

        if (this.isAuthenticated) {
            console.log('[CertificatesLoader] Добавляем контролы для аутентифицированного пользователя');
            for (let i = 0; i < certificateElements.length; i++) {
                const certificateElement = certificateElements[i];
                const certificate = certificateItems[i];
                this.addBlockControls(certificateElement, certificate);
                this.setupContentEditing(certificateElement);
            }
        }

        // Инициализируем аккордеоны на мобильных после рендеринга
        if (this.isMobile) {
            this.initializeAccordions();
        }
    }

    setupContentEditing(certificateElement) {
        console.log('[CertificatesLoader] Настраиваем редактирование контента для блока');

        const contentElements = certificateElement.querySelectorAll('[data-content]');
        console.log(`[CertificatesLoader] Найдено ${contentElements.length} элементов для редактирования`);

        contentElements.forEach((element, index) => {
            const tagId = element.getAttribute('data-content');
            console.log(`[CertificatesLoader] Настраиваем редактирование для элемента ${index + 1}: ${tagId}`);

            try {
                setupEditButton(element);
                console.log(`[CertificatesLoader] Кнопка редактирования добавлена для ${tagId}`);
            } catch (error) {
                console.error(`[CertificatesLoader] Ошибка добавления кнопки редактирования для ${tagId}:`, error);
            }
        });
    }

    createCertificateElement(certificate, globalIndex) {
        console.log('[CertificatesLoader] createCertificateElement() для:', certificate.data_block_name);

        const certificateItem = document.createElement('div');
        certificateItem.className = 'certificate-block';
        certificateItem.setAttribute('data-block-name', certificate.data_block_name);
        certificateItem.setAttribute('data-block-id', certificate.id);
        certificateItem.setAttribute('data-order', String(globalIndex));
        certificateItem.style.position = 'relative';

        const blockName = certificate.data_block_name;

        // Разная разметка для мобильных и десктопа
        if (this.isMobile) {
            // language=HTML
            certificateItem.innerHTML = `
                <div class="accordion-main certificate-accordion">
                    <div class="row">
                        <div class="col-12">
                            <div class="certificate-header d-flex justify-content-between align-items-center">
                                <h4 data-content="${blockName}-title" data-global="true" style="margin: 0;"></h4>
                                <button class="open-accordion"
                                        style="background: none; border: none; cursor: pointer; padding: 0;">
                                    <img src="/images/accordion-closed.svg" alt="open"
                                         style="width: 24px; height: 24px;">
                                </button>
                                <button class="close-accordion"
                                        style="background: none; border: none; cursor: pointer; display: none; padding: 0;">
                                    <img src="/images/opened-accordion.svg" alt="close"
                                         style="width: 24px; height: 24px;">
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="accordion-inner"
                         style="max-height: 0; overflow: hidden; transition: max-height 0.3s ease;">
                        <div class="row mt-3">
                            <div class="col-12">
                                <!-- Только дата, без дублирования h4 -->
                                <p class="publication-date" data-content="${blockName}-date" data-global="true"
                                   data-type="date"
                                   style="margin-bottom: 15px; font-size: 14px; opacity: 0.8;"></p>
                                <p data-content="${blockName}-description" data-type="textarea" data-global="true"></p>
                                <img class="certificate-mobile-image" src="" alt="Certificate Image" data-content="${blockName}-image" data-type="image"
                                     data-global="true">
                            </div>
                        </div>
                    </div>
                </div>
            `;
        } else {
            // Десктопная версия (оригинальная)
            certificateItem.innerHTML = `
            <div class="row">
                <div class="col-md-6 news-preview-meta">
                    <p class="publication-date" data-content="${blockName}-date" data-global="true" data-type="date"></p>
                    <img class="certificate-image-deckstop" src="" alt="Certificate Image" data-content="${blockName}-image" data-type="image" data-global="true" 
                         style="width: 100%; max-width: 300px; height: auto; border-radius: 8px; margin-top: 10px;">
                </div>
                <div class="col-md-6">
                    <div class="row">
                        <div class="col-10">
                            <h4 data-content="${blockName}-title" data-global="true"></h4>
                            <p data-content="${blockName}-description" data-type="textarea" data-global="true"></p>
                        </div>
                        <div class="col-2 d-flex justify-content-end">
                            <a href="#" class="news-link" data-content="${blockName}-document" data-type="document" data-global="true">
                                <img src="images/news-button.svg" alt="download-button" class="news-button default">
                                <img src="images/news-button-hover.svg" alt="download-button-hover" class="news-button hover">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        `;
        }

        return certificateItem;
    }

    // Инициализация аккордеонов для мобильных
    initializeAccordions() {
        console.log('[CertificatesLoader] Инициализируем аккордеоны для мобильных');

        const accordions = this.container.querySelectorAll('.certificate-accordion');

        accordions.forEach(accordion => {
            const openBtn = accordion.querySelector('.open-accordion');
            const closeBtn = accordion.querySelector('.close-accordion');
            const accordionInner = accordion.querySelector('.accordion-inner');
            const header = accordion.querySelector('.certificate-header');

            if (openBtn && closeBtn && accordionInner && header) {
                // Удаляем старые обработчики если есть
                const newOpenBtn = openBtn.cloneNode(true);
                const newCloseBtn = closeBtn.cloneNode(true);
                const newHeader = header.cloneNode(true);

                // Заменяем кнопки в новом хедере
                const oldOpenInHeader = newHeader.querySelector('.open-accordion');
                const oldCloseInHeader = newHeader.querySelector('.close-accordion');
                if (oldOpenInHeader) oldOpenInHeader.replaceWith(newOpenBtn);
                if (oldCloseInHeader) oldCloseInHeader.replaceWith(newCloseBtn);

                // Заменяем весь хедер
                header.parentNode.replaceChild(newHeader, header);

                // Добавляем обработчик на весь хедер
                newHeader.addEventListener('click', (e) => {
                    // Проверяем что не кликнули по кнопке (она сама обработает)
                    if (!e.target.closest('.open-accordion') && !e.target.closest('.close-accordion')) {
                        const isOpen = accordionInner.classList.contains('open');
                        this.toggleAccordion(accordion, !isOpen);
                    }
                });

                // Добавляем обработчики на кнопки
                newOpenBtn.addEventListener('click', (e) => {
                    e.stopPropagation(); // Останавливаем всплытие
                    this.toggleAccordion(accordion, true);
                });

                newCloseBtn.addEventListener('click', (e) => {
                    e.stopPropagation(); // Останавливаем всплытие
                    this.toggleAccordion(accordion, false);
                });

                // Делаем хедер кликабельным визуально
                newHeader.style.cursor = 'pointer';
            }
        });
    }

    // Переключение аккордеона
    // Переключение аккордеона
    toggleAccordion(accordion, shouldOpen) {
        const accordionInner = accordion.querySelector('.accordion-inner');
        const openBtn = accordion.querySelector('.open-accordion');
        const closeBtn = accordion.querySelector('.close-accordion');
        const headerTextElements = accordion.querySelectorAll('.certificate-header h4, .certificate-header p');
        const innerTextElements = accordionInner.querySelectorAll('h4, p');
        const certificateBlock = accordion.closest('.certificate-block'); // Находим родительский certificate-block

        console.log('[CertificatesLoader] toggleAccordion:', shouldOpen ? 'открываем' : 'закрываем');

        if (shouldOpen) {
            // Открываем
            // Сначала делаем видимым для расчета высоты
            accordionInner.style.display = 'block';
            // Даем браузеру время на рендеринг
            setTimeout(() => {
                const scrollHeight = accordionInner.scrollHeight;
                accordionInner.style.maxHeight = scrollHeight + 'px';
                console.log('[CertificatesLoader] Установлена высота:', scrollHeight);
            }, 10);

            accordionInner.classList.add('open');
            accordion.classList.add('accordion-container-open');

            // Добавляем градиентный фон блоку certificate-block
            certificateBlock.style.background = 'linear-gradient(143deg, #19b5e1 0%, #0090b8 100%)';

            // Меняем цвет текста в хедере на белый
            headerTextElements.forEach(el => {
                el.classList.add('text-color-white');
                el.style.setProperty('color', 'white', 'important');
            });

            // Меняем цвет текста внутри аккордеона на белый
            innerTextElements.forEach(el => {
                el.classList.add('text-color-white');
                el.style.setProperty('color', 'white', 'important');
            });

            openBtn.style.display = 'none';
            closeBtn.style.display = 'inline-block';
        } else {
            // Закрываем
            accordionInner.style.maxHeight = '0';
            accordionInner.classList.remove('open');
            accordion.classList.remove('accordion-container-open');

            // Убираем градиентный фон с certificate-block
            certificateBlock.style.removeProperty('background');

            // Возвращаем исходный цвет текста в хедере
            headerTextElements.forEach(el => {
                el.classList.remove('text-color-white');
                el.style.removeProperty('color');
            });

            // Возвращаем исходный цвет текста внутри
            innerTextElements.forEach(el => {
                el.classList.remove('text-color-white');
                el.style.removeProperty('color');
            });

            setTimeout(() => {
                openBtn.style.display = 'inline-block';
                closeBtn.style.display = 'none';
                accordionInner.style.display = 'none';
            }, 300);
        }
    }


    addBlockControls(certificateElement, certificate) {
        console.log(`[CertificatesLoader] Добавляем контролы для блока ${certificate.data_block_name}`);

        if (!certificateElement.querySelector('.block-delete-button')) {
            const blockId = certificateElement.getAttribute('data-block-id');
            if (blockId) {
                addDeleteButton(certificateElement, blockId);
                console.log(`[CertificatesLoader] Кнопка удаления добавлена`);
            }
        }

        if (!certificateElement.hasAttribute('draggable')) {
            certificateElement.setAttribute('draggable', 'true');
            makeBlockDraggable(certificateElement);
            console.log(`[CertificatesLoader] Блок сделан перетаскиваемым`);
        }
    }

    async _fillEmptySsrImages() {
        const imgs = this.container.querySelectorAll('img[data-content][data-type="image"]');
        for (const img of imgs) {
            if (!img.src || img.src === window.location.href) {
                const tagId = img.getAttribute('data-content');
                const isGlobal = img.getAttribute('data-global') === 'true';
                try {
                    const data = await loadContentForElement(img, '', tagId, isGlobal);
                    if (data) applyContentToElement(img, data);
                } catch (e) {
                    console.warn('[CertificatesLoader] Failed to fill SSR image:', tagId, e);
                }
            }
        }
    }

    async loadCertificateContent(certificateElement, certificate) {
        console.log('[CertificatesLoader] loadCertificateContent() для:', certificate.data_block_name);

        const contentElements = certificateElement.querySelectorAll('[data-content]');
        console.log('[CertificatesLoader] Найдено элементов с data-content:', contentElements.length);

        for (let i = 0; i < contentElements.length; i++) {
            const element = contentElements[i];
            const tagId = element.getAttribute('data-content');
            const isGlobal = element.getAttribute('data-global') === 'true';

            try {
                const data = await loadContentForElement(element, '', tagId, isGlobal);
                if (data) {
                    applyContentToElement(element, data);
                } else {
                    this.setDefaultContent(element, certificate, tagId);
                }
            } catch (error) {
                console.warn(`[CertificatesLoader] Ошибка загрузки контента для ${tagId}:`, error);
                this.setDefaultContent(element, certificate, tagId);
            }
        }
    }

    setDefaultContent(element, certificate, tagId) {
        if (tagId.endsWith('-title')) {
            element.textContent = 'Сертифікат';
        } else if (tagId.endsWith('-description')) {
            element.textContent = 'Опис сертифіката';
        } else if (tagId.endsWith('-date')) {
            element.textContent = this.formatDate(new Date());
        }
    }

    formatDate(dateString) {
        if (!dateString) return '';

        try {
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return '';

            const months = [
                'січня', 'лютого', 'березня', 'квітня', 'травня', 'червня',
                'липня', 'серпня', 'вересня', 'жовтня', 'листопада', 'грудня'
            ];

            const day = date.getDate();
            const month = months[date.getMonth()];
            const year = date.getFullYear();

            return `${day} ${month} ${year}`;
        } catch (error) {
            console.error('[CertificatesLoader] Ошибка форматирования даты:', error);
            return '';
        }
    }

    updateLoadMoreButton(state) {
        if (!this.loadMoreButton) return;

        switch (state) {
            case 'loading':
                this.loadMoreButton.textContent = 'завантажується...';
                this.loadMoreButton.disabled = true;
                this.loadMoreButton.style.opacity = '0.6';
                break;

            case 'ready':
                this.loadMoreButton.textContent = 'завантажити більше';
                this.loadMoreButton.disabled = false;
                this.loadMoreButton.style.opacity = '1';
                this.loadMoreButton.style.display = 'block';
                break;

            case 'no-more':
                this.loadMoreButton.textContent = 'усі сертифікати завантажено';
                this.loadMoreButton.disabled = true;
                this.loadMoreButton.style.opacity = '0.6';
                setTimeout(() => {
                    if (this.loadMoreButton) {
                        this.loadMoreButton.style.display = 'none';
                    }
                }, 3000);
                break;
        }
    }

    showLoadMoreError() {
        if (this.loadMoreButton) {
            this.loadMoreButton.textContent = 'помилка завантаження';
            this.loadMoreButton.disabled = false;
            this.loadMoreButton.style.opacity = '1';

            setTimeout(() => {
                this.updateLoadMoreButton('ready');
            }, 3000);
        }
    }

    renderEmptyState() {
        console.log('[CertificatesLoader] renderEmptyState()');
        this.container.innerHTML = `
            <div class="certificates-empty-state" style="text-align: center; padding: 40px;">
                <h3>Сертифікати скоро з'являться</h3>
                <p>Наразі немає доступних сертифікатів</p>
            </div>
        `;

        if (this.loadMoreButton) {
            this.loadMoreButton.style.display = 'none';
        }
    }

    renderErrorState() {
        console.log('[CertificatesLoader] renderErrorState()');
        this.container.innerHTML = `
            <div class="certificates-error-state" style="text-align: center; padding: 40px;">
                <h3>Не вдалося завантажити сертифікати</h3>
                <p>Спробуйте оновити сторінку</p>
                <button onclick="location.reload()" style="
                    padding: 10px 20px;
                    background-color: #4CAF50;
                    color: white;
                    border: none;
                    border-radius: 4px;
                    cursor: pointer;
                    margin-top: 10px;
                ">Оновити сторінку</button>
            </div>
        `;

        if (this.loadMoreButton) {
            this.loadMoreButton.style.display = 'none';
        }
    }

    // Перестройка существующих сертификатов при изменении режима
    rebuildExistingCertificates() {
        console.log('[CertificatesLoader] rebuildExistingCertificates начало, isMobile:', this.isMobile);

        // Находим ВСЕ блоки сертификатов, включая те что в аккордеонах
        const existingCertificates = this.container.querySelectorAll('.certificate-block');
        console.log('[CertificatesLoader] Найдено сертификатов для перестройки:', existingCertificates.length);

        if (existingCertificates.length === 0) {
            console.warn('[CertificatesLoader] Нет сертификатов для перестройки!');
            return;
        }

        const certificatesData = [];

        // Сохраняем данные из существующих элементов
        existingCertificates.forEach((cert, index) => {
            const blockName = cert.getAttribute('data-block-name');
            const blockId = cert.getAttribute('data-block-id');
            const order = cert.getAttribute('data-order');

            console.log(`[CertificatesLoader] Сохраняем данные сертификата ${index}:`, blockName);

            // Сохраняем контент
            const contentData = {};
            const contentElements = cert.querySelectorAll('[data-content]');

            contentElements.forEach(el => {
                const tagId = el.getAttribute('data-content');
                if (el.tagName === 'IMG') {
                    contentData[tagId] = el.src;
                } else if (el.tagName === 'A') {
                    contentData[tagId] = el.getAttribute('href') || '';
                } else {
                    contentData[tagId] = el.textContent || el.innerText || '';
                }
            });

            certificatesData.push({
                blockName,
                blockId,
                order: parseInt(order) || index,
                content: contentData
            });
        });

        console.log('[CertificatesLoader] Сохранено данных сертификатов:', certificatesData.length);

        // Очищаем контейнер
        this.container.innerHTML = '';

        // Пересоздаем элементы с новой разметкой
        certificatesData.forEach((data) => {
            const certificate = {
                data_block_name: data.blockName,
                id: data.blockId
            };

            console.log('[CertificatesLoader] Создаем элемент для:', data.blockName, 'режим:', this.isMobile ? 'мобильный' : 'десктоп');

            const newElement = this.createCertificateElement(certificate, data.order);
            this.container.appendChild(newElement);

            // Восстанавливаем контент
            Object.keys(data.content).forEach(tagId => {
                const element = newElement.querySelector(`[data-content="${tagId}"]`);
                if (element) {
                    if (element.tagName === 'IMG') {
                        element.src = data.content[tagId];
                    } else if (element.tagName === 'A') {
                        if (data.content[tagId]) element.setAttribute('href', data.content[tagId]);
                    } else {
                        element.textContent = data.content[tagId];
                    }
                }
            });

            // Добавляем контролы для аутентифицированных пользователей
            if (this.isAuthenticated) {
                this.addBlockControls(newElement, certificate);
                this.setupContentEditing(newElement);
            }
        });

        // Инициализируем аккордеоны на мобильных
        if (this.isMobile) {
            console.log('[CertificatesLoader] Инициализируем аккордеоны после перестройки');
            setTimeout(() => this.initializeAccordions(), 100);
        }

        console.log('[CertificatesLoader] Перестройка завершена');
    }

    async reload() {
        console.log('[CertificatesLoader] Перезагрузка сертификатов');
        this.currentOffset = 0;
        this.loadedCertificatesCount = 0;
        this.hasMoreCertificates = true;
        await this.loadInitialCertificates();
    }
}

console.log('[CertificatesLoader] Создаем экземпляр');
export const certificatesLoader = new CertificatesLoader();